import Swal from 'sweetalert2'

/***
 *
 * {
 *     title: 'title',
 *     content: 'content',
 *     actions: [
 *       {
 *          label: 'Yes',
 *          onClick: () => {},
 *       },
 *       {
 *          label: 'No',
 *          onClick: () => {},
 *       },
 *       ...
 *     ]
 * }
 *
 **/
 
export const sweetAlert = async (props = {}) => {
  const { 
    title, 
    content, 
    actions: modalActions = [], 
    tr = (t) => t,
    ...rest
  } = props

  const swalConfig = {
    ...(title && { title }),
    ...(content && { text: content }),
    showCancelButton: true,
    cancelButtonText: tr('Close'),
    ...rest,
  }

  // Map first action as confirm button
  if (modalActions.length > 0) {
    swalConfig.confirmButtonText = modalActions[0].label
  }
  // Map second action as cancel button override
  if (modalActions.length > 1) {
    swalConfig.cancelButtonText = modalActions[1].label
  }

  try {
    const result = await Swal.fire(swalConfig)

    if (result.isConfirmed && modalActions.length > 0) {
      const confirmAction = modalActions[0]
      if (confirmAction.onClick) await confirmAction.onClick()
    }

    if (result.isDismissed && modalActions.length > 1) {
      const cancelAction = modalActions[1]
      if (cancelAction.onClick) await cancelAction.onClick()
    }

    Swal.close()
  } catch(e) {
    throw e
  }
}
